import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import BaseComponent from 'foundation/base-component';
import { SIFantasyGamesLayout } from './si-fantasy-games-layout';
import { embedScript, hasValue, isScriptEmbedded } from '../../../general/js/general-helpers';

class SIFantasyGamesComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.init();
    }

    init() {
        this.render();
        if (document.readyState === 'complete') {
            this.loadScripts();
        } else {
            window.addEventListener('load', () => {
                this.loadScripts();
            });
        }
    }

    loadScripts() {
        const { scripts } = this.options;

        if (!hasValue(scripts)) {
            return;
        }

        scripts.forEach((script) => {
            const { scriptSourceUrl, scriptType, integrity } = script;
            const innerHTML = '';

            if (!isScriptEmbedded(scriptSourceUrl, innerHTML)) {
                const { loadScriptAsync, useNoModule } = script;

                embedScript(
                    scriptSourceUrl,
                    loadScriptAsync,
                    this.loadRouteToHoleClipTag,
                    useNoModule,
                    scriptType,
                    innerHTML,
                    integrity,
                );
            }
        });
    }

    onDestroy() {
        ReactDOM.unmountComponentAtNode(this.element);
    }

    render() {
        ReactDOM.render(
            <Fragment>
                <SIFantasyGamesLayout {...this.options} />
            </Fragment>,
            this.element
        );
    }
}

export default SIFantasyGamesComponent;
